import PropTypes from 'prop-types';
import React, { Component } from "react";
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { rideDetailsFromEntry } from 'modules/HorseRacing/utils';
import BetLink from 'modules/Common/containers/BetLink';
import Dropdown from 'modules/Common/components/Dropdown';
import { sortByHorseName, sortByClothNumber, sortByOdds } from 'utils/compare';

export default class HorseRacingLiveShowPage extends Component {
  static propTypes = {
    helmetRaceLabel: PropTypes.string,
    race: PropTypes.object
  };

  constructor(...args) {
    super(...args);

    this.state = this.getStateForRunners(this.props, true);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateForRunners(nextProps, this.state.sortPristine));
  }

  getStateForRunners({race: {rides}}, sortPristine = true) {
    const runners = rides.filter(ride => (ride.ride_status == "RUNNER"));
    const haveHistoricalOdds = runners.map(runner => runner.betting.historical_odds.length).some(r => r);
    const haveCurrentOdds = runners.map(runner => runner.betting.current_odds).some(r => r);
    const nextState = {runners, sortPristine, haveCurrentOdds, haveHistoricalOdds};

    if (sortPristine) {
      if (haveHistoricalOdds) {
        nextState.sortOrder = "odds";
      }
      else {
        nextState.sortOrder = "cloth";
      }
    }

    return nextState;
  }

  setSortOrder(sortOrder) {
    this.setState({
      sortOrder,
      sortPristine: false
    });
  }

  render() {
    const {
      helmetRaceLabel,
      race,
      race: {
        on_course_book_percentage
      }
    } = this.props;

    const {runners, sortOrder, haveCurrentOdds} = this.state;

    switch (sortOrder) {
      case "horse":
        runners.sort(sortByHorseName);
        break;
      case "odds":
        runners.sort(sortByOdds);
        break;
      case "cloth":
      default:
        runners.sort(sortByClothNumber);
        break;
    }

    const sortOptions = [
      {text: "Cloth number", value: "cloth"},
      {text: "Horse A-Z",    value: "horse"}
    ];

    if (haveCurrentOdds) {
      sortOptions.splice(1, 0, {text: "Odds", value: "odds"});
    }

    return <div className="hr-racing-live-show">
      <MetaDataWrapper title={`${helmetRaceLabel} - Live Show`}/>
      <div className="hr-live-show-sort">
        <span className="hr-racecard-sort-text">Sort By:</span>
        <Dropdown
          className="sort-dropdown"
          options={sortOptions}
          value={this.state.sortOrder}
          onChange={(value) => this.setSortOrder(value)}
          title="Order?"
          showSelected
          noOptionsMessage="No options"
        />
      </div>
      <table className="default-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Horse</th>
            <th>On-Course Prices</th>
            <th><span className="hr-odds-heading">Odds</span></th>
          </tr>
        </thead>
        <tbody>
          {runners.map(ride => {
            const {
              ride_reference: {
                id
              },
              cloth_number,
              horse: {
                name
              },
              betting: {
                current_odds = "",
                historical_odds = []
              }
            } = ride;

            const {betlinkProps} = rideDetailsFromEntry({race, ride});

            return <tr key={id}>
              <td>{cloth_number}</td>
              <td>{name}</td>
              <td className="hr-racing-live-show-prices">
                {historical_odds.map((price, i) => <span key={i}>{price}</span>)}
              </td>
              <td><BetLink className="hr-betting-link" {...betlinkProps}>{current_odds}</BetLink></td>
            </tr>;
          })}
        </tbody>
      </table>
      <dl>
        {on_course_book_percentage && <dt className="pool-label">On-course book percentage</dt>}
          <dd className="pool-value">{on_course_book_percentage}</dd>
      </dl>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingLiveShowPage.js